import styled from "styled-components";
import { desktopMarginsCutoff } from "../../../styleConstants";
import VvPhoneNumber from "../../../Components/VvPhoneNumber";

const Wrapper = styled.div`
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 14px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: 16px;
  }
`;

const Headline = styled.div`
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.45);

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    margin-bottom: 0px;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 300;
  }
`;

const Details = styled.div`
  color: rgba(0, 0, 0, 0.7);

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    color: rgba(0, 0, 0, 0.95);
    font-weight: 500;
  }
`;

const VerificationHelpFooter = () => {
  return (
    <Wrapper>
      <Headline>
        Contact us for any questions, help, or verification assistance.
      </Headline>
      <Details>
        <VvPhoneNumber /> · info@verifiedvoice.org
      </Details>
    </Wrapper>
  );
};

export default VerificationHelpFooter;
